/**
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 2020-Oct-22
 *
 * bestgob-client - orders.module.js
 **/
import router from './../config/router';
import {Orders} from '../api';
import {
    cancelOrderRequest,
    createOrderRequest,
    detailsOrderRequest,
    editOrderRequest,
    generateInvoiceOrderRequest,
    ordersRequestModel,
    paymentStatusOrderRequest,
    payOrderRequest
} from '../api/models';
import {toFormData, toFormDataForCart} from '../core/utils';

const processesModule = {
    namespaced: true,
    state: {
        ordersData: null,
        createOrderResponse: null,
        orderData: null,
        paymentResponse: null
    },
    getters: {
        hasPagination: state => {
            return state.ordersData != null;
        },

        orders: state => {
            return state.ordersData.orders;
        },

        paginator: state => {
            return state.ordersData.paginator;
        },

        proceduresCounter: state => {
            return state.ordersData.countTramitesCarrito;
        },

        //Order Edit
        order: state => {
            return state.orderData.orden;
        },

        proceduresGroup: state => {
            return state.orderData.tramitesCarrito;
        }
    },
    actions: {
        async getOrders({commit, dispatch}, request = ordersRequestModel()) {
            dispatch('alerts/showLoading', 'Obteniendo listado de órdenes', {root: true});
            await dispatch('account/checkAuthExpiration', null, {root: true});

            Orders.getListByStatus(toFormData(request))
                .then(data => {
                    dispatch('alerts/hideLoading', null, {root: true});
                    commit('getOrdersSuccess', data);
                })
                .catch(error => {
                    dispatch('alerts/error', error.message, {root: true});
                });
        },

        async createOrder({dispatch, commit}, request = createOrderRequest()) {
            dispatch('alerts/showLoading', 'Creando orden de pago', {root: true});
            await dispatch('account/checkAuthExpiration', null, {root: true});

            Orders.create(toFormDataForCart(request))
                .then(data => {
                    dispatch('alerts/hideLoading', null, {root: true});
                    commit('successCreateOrder', data);
                    console.log(JSON.stringify(data));
                })
                .catch(error => {
                    dispatch('alerts/error', error.message, {root: true});
                    router.push({name: 'orders', params: {action: 'list'}});
                });
        },

        async getPaymentStatusOrder({dispatch}, request = paymentStatusOrderRequest()) {
            dispatch('alerts/showLoading', 'Recopilando estatus del pago', {root: true});
            await dispatch('account/checkAuthExpiration', null, {root: true});

            Orders.getPaymentStatus(toFormDataForCart(request))
                .then(data => {
                    dispatch('alerts/hideLoading', null, {root: true});

                    if (data.success) {
                        dispatch('alerts/success', data.message, {root: true});
                    } else {
                        dispatch('alerts/error', data.message, {root: true});
                    }

                    router.push({name: 'orders_details', params: {action: 'edit', id: request.id}});
                })
                .catch(error => {
                    dispatch('alerts/error', error.message, {root: true});

                    router.push({name: 'orders_details', params: {action: 'edit', id: request.id}});
                });
        },

        async editOrder({dispatch, commit}, request = editOrderRequest()) {
            dispatch('alerts/showLoading', 'Obteniendo información de la Orden', {root: true});
            await dispatch('account/checkAuthExpiration', null, {root: true});

            Orders.edit(toFormDataForCart(request))
                .then(data => {
                    dispatch('alerts/hideLoading', null, {root: true});
                    commit('setOrderContent', data);
                })
                .catch(error => {
                    dispatch('alerts/error', error.message, {root: true});
                });
        },

        async detailsOrder({dispatch, commit}, request = detailsOrderRequest()) {
            dispatch('alerts/showLoading', 'Obteniendo información de la Orden', {root: true});
            await dispatch('account/checkAuthExpiration', null, {root: true});

            Orders.details(toFormDataForCart(request))
                .then(data => {
                    console.log(JSON.stringify(data));
                    dispatch('alerts/hideLoading', null, {root: true});
                    commit('setOrderDetails', {index: request.index, response: data});
                })
                .catch(error => {
                    dispatch('alerts/error', error.message, {root: true});
                });
        },

        async getCheckoutDetails({dispatch, commit}, request = editOrderRequest()) {
            dispatch('alerts/showLoading', 'Obteniendo los detalles de la orden de pago.', {root: true});
            await dispatch('account/checkAuthExpiration', null, {root: true});

            Orders.checkoutDetails(toFormDataForCart(request))
                .then(data => {
                    dispatch('alerts/hideLoading', null, {root: true});
                    commit('setCheckoutDetails', data);
                })
                .catch(error => {
                    dispatch('alerts/error', error.message, {root: true});
                });
        },

        async payOrder({dispatch, commit}, request = payOrderRequest()) {
            dispatch('alerts/showLoading', 'Iniciando el proceso de pago.', {root: true});
            await dispatch('account/checkAuthExpiration', null, {root: true});

            Orders.pay(toFormDataForCart(request))
                .then(data => {
                    console.log(JSON.stringify(data));
                    dispatch('alerts/hideLoading', null, {root: true});
                    commit('successPaymentRequest', data);
                })
                .catch(error => {
                    dispatch('alerts/error', error.message, {root: true});
                });
        },

        async cancelOrder({dispatch}, request = cancelOrderRequest()) {
            dispatch('alerts/showLoading', 'Cancelando orden de pago.', {root: true});
            await dispatch('account/checkAuthExpiration', null, {root: true});

            Orders.cancel(toFormDataForCart(request))
                .then(data => {
                    dispatch('alerts/hideLoading', null, {root: true});
                    dispatch('alerts/success', data.message, {root: true});

                    let requestEdit = editOrderRequest();
                    requestEdit.id = request.id;
                    dispatch('orders/editOrder', requestEdit, {root: true});
                })
                .catch(error => {
                    dispatch('alerts/error', error.message, {root: true});
                });
        },

        async generateInvoiceOrder({dispatch}, request = generateInvoiceOrderRequest()) {
            dispatch('alerts/showLoading', 'Generando factura solicitada', {root: true});
            await dispatch('account/checkAuthExpiration', null, {root: true});

            Orders.generateInvoice(toFormDataForCart(request))
                .then(data => {
                    console.log(JSON.stringify(data));
                    dispatch('alerts/hideLoading', null, {root: true});
                    dispatch('alerts/success', data.message, {root: true});

                    /*let requestEdit = editOrderRequest()
                    requestEdit.id = router.currentRoute.params.id
                    dispatch('orders/editOrder', requestEdit, {root: true})*/
                })
                .catch(error => {
                    dispatch('alerts/error', error.message, {root: true});
                });
        }
    },

    mutations: {
        getOrdersSuccess(state, data) {
            delete data.tramitesCarrito;
            state.ordersData = data;
        },

        successCreateOrder(state, data) {
            state.createOrderResponse = data;
        },

        setOrderContent(state, data) {
            state.orderData = data;
        },

        setOrderDetails(state, data) {
            state.orderData.tramitesCarrito[data.index].tramitesCarrito = data.response.tramitesCarrito;
            state.orderData.tramitesCarrito[data.index].etapas = data.response.etapas;
            state.orderData.tramitesCarrito[data.index].totalTramitesCarrito = 1;

        },

        setCheckoutDetails(state, data) {
            state.orderData.tramitesCheckout = data;
            state.orderData.tramitesCheckoutItems = 1;
        },

        successPaymentRequest(state, data) {
            state.paymentResponse = data;
        }
    }
};

export default processesModule;